// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__H5fRQ","loaderTextContainer":"Loading_loaderTextContainer__4wg5P","loaderText":"Loading_loaderText__F3Bxw"};